import { useGlobals } from 'context'
import { isAuthorized } from 'helpers'
import { useEffect, useState } from 'react'

export default function useAuth(allowedRoles) {
  const { global } = useGlobals()
  const [isAuthed, setIsAuthed] = useState(false)
  const { user } = global || {}
  const { roles } = user || {}

  useEffect(() => {
    if (roles) {
      const isUserAuthorized = isAuthorized(roles, allowedRoles)
      if (typeof isUserAuthorized === 'boolean') {
        setIsAuthed(isUserAuthorized)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roles])

  return isAuthed
}
